(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["macros.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["result", "icons"], 
[], 
function (l_result, l_icons, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("result", l_result);
frame.set("icons", l_icons);
var t_2 = "";t_2 += "\n<article class=\"topic-article ";
t_2 += runtime.suppressValue(runtime.memberLookup((l_result),"type"), env.opts.autoescape);
t_2 += "\">\n  <div class=\"topic-article--icon-wrap\">\n    ";
if(runtime.memberLookup((l_result),"type") == "document") {
t_2 += "\n      ";
var t_3;
t_3 = "search-result.kb-article";
frame.set("link_name", t_3, true);
if(frame.topLevel) {
context.setVariable("link_name", t_3);
}
if(frame.topLevel) {
context.addExport("link_name", t_3);
}
t_2 += "\n    <img class=\"topic-article--icon\" src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_icons),"reader_mode"), env.opts.autoescape);
t_2 += "\" alt=\"\">\n    ";
;
}
else {
if(runtime.memberLookup((l_result),"type") == "question") {
t_2 += "\n      ";
var t_4;
t_4 = "search-result.support-forum-question-details";
frame.set("link_name", t_4, true);
if(frame.topLevel) {
context.setVariable("link_name", t_4);
}
if(frame.topLevel) {
context.addExport("link_name", t_4);
}
t_2 += "\n    <img class=\"topic-article--icon\" src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_icons),"blog"), env.opts.autoescape);
t_2 += "\" alt=\"\">\n    ";
;
}
else {
t_2 += "\n      ";
var t_5;
t_5 = "search-result.other";
frame.set("link_name", t_5, true);
if(frame.topLevel) {
context.setVariable("link_name", t_5);
}
if(frame.topLevel) {
context.addExport("link_name", t_5);
}
t_2 += "\n    ";
;
}
;
}
t_2 += "\n  </div>\n  <div class=\"topic-article--text\">\n    <h3 class=\"sumo-card-heading\">\n      <a class=\"title\" href=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_result),"url"), env.opts.autoescape);
t_2 += "\"\n        data-event-name=\"link_click\"\n        data-event-parameters='{\n          \"link_name\": \"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "link_name"), env.opts.autoescape);
t_2 += "\"\n          ";
if(runtime.memberLookup((l_result),"rank")) {
t_2 += ",\n          \"search_result_source\": \"";
if(runtime.memberLookup((l_result),"type") == "document") {
t_2 += "kb";
;
}
else {
t_2 += "aaq";
;
}
t_2 += "\",\n          \"search_result_rank\": ";
t_2 += runtime.suppressValue(runtime.memberLookup((l_result),"rank"), env.opts.autoescape);
t_2 += ",\n          \"search_result_evidence_locale\": \"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_result),"evidence_locale"), env.opts.autoescape);
t_2 += "\",\n          \"search_result_display_locale\": \"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_result),"display_locale"), env.opts.autoescape);
t_2 += "\",\n          \"search_result_locale_fallback\": ";
if(runtime.memberLookup((l_result),"locale_fallback")) {
t_2 += "1";
;
}
else {
t_2 += "0";
;
}
t_2 += "\n          ";
;
}
t_2 += "\n        }'>\n        ";
t_2 += runtime.suppressValue(runtime.memberLookup((l_result),"title"), env.opts.autoescape);
t_2 += "\n      </a>\n    </h3>\n\n    ";
if(runtime.memberLookup((l_result),"type") == "question") {
t_2 += "\n      <ul class=\"topic-article--meta-list thread-meta\">\n        ";
if(runtime.memberLookup((l_result),"is_solved")) {
t_2 += "\n          ";
t_2 += "\n          <li>";
t_2 += runtime.suppressValue((lineno = 35, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Solved"])), env.opts.autoescape);
t_2 += "</li>\n        ";
;
}
t_2 += "\n        <li>\n          ";
if(runtime.memberLookup((l_result),"num_answers") > 0) {
t_2 += "\n            ";
t_2 += runtime.suppressValue(env.getFilter("f").call(context, (lineno = 39, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ngettext"), "ngettext", context, ["1 reply","%s replies",runtime.memberLookup((l_result),"num_answers")])),[runtime.memberLookup((l_result),"num_answers")]), env.opts.autoescape);
t_2 += "\n          ";
;
}
else {
t_2 += "\n            ";
t_2 += runtime.suppressValue((lineno = 41, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["No replies"])), env.opts.autoescape);
t_2 += "\n          ";
;
}
t_2 += "\n        </li>\n        <li>\n          ";
t_2 += runtime.suppressValue(env.getFilter("f").call(context, (lineno = 45, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ngettext"), "ngettext", context, ["1 person has this problem","%s people have this problem",runtime.memberLookup((l_result),"num_votes")])),[runtime.memberLookup((l_result),"num_votes")]), env.opts.autoescape);
t_2 += "\n        </li>\n        ";
if(runtime.memberLookup((l_result),"num_votes_past_week")) {
t_2 += "\n          <li>\n            ";
t_2 += runtime.suppressValue(env.getFilter("f").call(context, (lineno = 49, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ngettext"), "ngettext", context, ["1 new this week","%s new this week",runtime.memberLookup((l_result),"num_votes_past_week")])),[runtime.memberLookup((l_result),"num_votes_past_week")]), env.opts.autoescape);
t_2 += "\n          </li>\n        ";
;
}
t_2 += "\n      </ul>\n    ";
;
}
t_2 += "\n    <p>";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_result),"search_summary")), env.opts.autoescape);
t_2 += "</p>\n  </div>\n</article>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("search_result");
context.setVariable("search_result", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
